import { useState } from 'react';
import '../styles/Header.css';

function Header({ currentPage, setCurrentPage }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const handleNavClick = (page) => {
    setCurrentPage(page);
    setShowDropdown(false);
    setShowMobileMenu(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const services = [
    { name: 'Big Data', page: 'BigData' },
    { name: 'Java', page: 'Java' },
    { name: 'Power BI', page: 'PowerBI' },
    { name: 'Dev Ops', page: 'DevOps' },
    { name: 'Life Science Services', page: 'LifeScienceServices' },
    { name: 'Healthcare Services', page: 'HealthcareServices' }
  ];

  const isServicePage = services.some((s) => s.page === currentPage);

  return (
    <header className="header">
      <div className="header-bar">
        <div className="logo">
          <img
            src="/images/logo.png"
            alt="DigiCloud Logo"
            onClick={() => handleNavClick('Home')}
          />
        </div>

        <button
          className="hamburger"
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          aria-label="Toggle menu"
        >
          ☰
        </button>

        <nav className={`nav ${showMobileMenu ? 'active' : ''}`}>
          <button
            className={currentPage === 'AboutUs' ? 'nav-link active-link' : 'nav-link'}
            onClick={() => handleNavClick('AboutUs')}
          >
            About
          </button>

          <div className="dropdown">
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className={`nav-link dropdown-btn ${isServicePage ? 'active-link' : ''}`}
            >
              Services
              <span className={`caret ${showDropdown ? 'open' : ''}`} aria-hidden="true">
                <svg viewBox="0 0 24 24" width="14" height="14">
                  <path fill="currentColor" d="M7 10l5 5 5-5z" />
                </svg>
              </span>
            </button>
            {showDropdown && (
              <div className="dropdown-menu">
                {services.map((service) => (
                  <button
                    key={service.page}
                    onClick={() => handleNavClick(service.page)}
                    className="dropdown-item"
                  >
                    {service.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          <button
            className={currentPage === 'Careers' ? 'nav-link active-link' : 'nav-link'}
            onClick={() => handleNavClick('Careers')}
          >
            Careers
          </button>

          <div className="nav-actions">
            <button className="nav-cta-btn" onClick={() => handleNavClick('Contact')}>
              Get In Touch
              <span className="cta-arrow" aria-hidden="true">›</span>
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
